<template>
  <div>
    <div class="text-h1"><slot name="title" /></div>
    <div v-if="$slots.description" class="text-label1 text-grey-darken-4 mt-1"><slot name="description" /></div>
  </div>
</template>
